import React, { FC, useCallback, useEffect } from 'react';

import { useMfaIssueDetailsQuery } from 'src/apps/mfa/hooks/useMfaIssueDetailsQuery';
import { ActionButtons } from 'src/apps/mobile-common/components/action-buttons/ActionButtons';
import { MobileTicketsSystems } from 'src/apps/mobile-common/components/mobile-tickets-systems/MobileTicketsSystems';
import { mapMobileIssueDetailsToReport } from 'src/apps/mobile-common/helpers/MobileIssueMapper';
import { MobileComponentDetailsBlock } from 'src/common/components/mobile-component-details-block/MobileComponentDetailsBlock';
import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { getBaseURL } from 'src/common/helpers/UrlNormalizingHelper';
import { ProductType } from 'src/common/interfaces/Tenant';
import { usePlatformConfigStore } from 'src/common/stores/platformConfigStore';

interface IMfaComponentDetailsBlockProps {
	issueId: string;
	runId: string;
	scanName: string;
	scanCreatedAt: string;
	issueNumber: string;
	isFullPageMode?: boolean;
	setError?: (error: unknown) => void;
}

export const MfaComponentDetailsBlock: FC<IMfaComponentDetailsBlockProps> = ({
	issueId,
	runId,
	scanName,
	scanCreatedAt,
	issueNumber,
	isFullPageMode,
	setError
}) => {
	const issueDetailsQuery = useMfaIssueDetailsQuery(issueId, runId);
	const { isDefaultJiraLabelsEnabled } = usePlatformConfigStore();

	useEffect(() => {
		if (issueDetailsQuery.isError) {
			setError?.(issueDetailsQuery.error);
		}
	}, [issueDetailsQuery.isError, issueDetailsQuery.error, setError]);

	const issuePageUrl = RoutesHelper.getMfaIssueInfoPath({ runId, issueId });
	const urlToCopy = `${getBaseURL()}${issuePageUrl}`;

	const openIssueInNewTab = useCallback((): void => {
		window.open(issuePageUrl, '_blank');
	}, [issuePageUrl]);

	const actionButtons = (
		<>
			{!isFullPageMode && <ActionButtons textToCopy={urlToCopy} openNewTab={openIssueInNewTab} />}
			{!issueDetailsQuery.isLoading && issueDetailsQuery.data && (
				<MobileTicketsSystems
					issue={mapMobileIssueDetailsToReport(
						issueDetailsQuery.data,
						issueId,
						isDefaultJiraLabelsEnabled,
						ProductType.MOBILE_FLOW_ANALYZER
					)}
				/>
			)}
		</>
	);

	return (
		<MobileComponentDetailsBlock
			isLoading={issueDetailsQuery.isLoading}
			issue={issueDetailsQuery.data}
			scanName={scanName}
			runTime={scanCreatedAt}
			issueNumber={issueNumber}
			actionButtons={actionButtons}
		/>
	);
};
